/**
 * @description
 * Returns State to it's initial values
 * @param {*} state
 */
const RESET_STATE = function(state, payload) {
    Object.assign(state, payload)
}

export default { RESET_STATE }
